<template>

  <div>

    <div
      class="buymodal-block__body">

      <transition
        name="slide-left"
        mode="out-in">
        <div>
          <div
            class="body-info questions">
            <div
              class="group"
              v-for="(item) in questions">
              {{ item.name }}
              <div
                class="question"
                v-for="(quest) in item.questions"
                >
                <label class="checkbox-container" @mouseenter="checkboxFocus($event,true)" @mouseleave="checkboxFocus($event,false)">{{ quest.question }}<a @click.prevent="openImg(quest.image, quest.description)">(?)</a>
                  <input type="checkbox" :grade=quest.grade :id=quest.id :name=quest.id v-model="ranswers[quest.id]" @change="checkboxChange($event)">
                  <span class="checkmark"></span>
                  <svg v-if="(minimumGrade() == quest.grade) && isQuestionDefect(quest)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ff3131" stroke-width="0.00024000000000000003" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.624"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM7.83335 12C7.4963 12 7.19244 12.2088 7.06346 12.5291C6.93447 12.8494 7.00577 13.2181 7.2441 13.4632L11.4107 17.7489C11.7362 18.0837 12.2638 18.0837 12.5893 17.7489L16.7559 13.4632C16.9942 13.2181 17.0655 12.8494 16.9365 12.5291C16.8076 12.2088 16.5037 12 16.1666 12H14V7C14 6.44771 13.5523 6 13 6H11C10.4477 6 10 6.44771 10 7V12H7.83335Z" fill="#ff3131"></path> </g></svg>
                </label>
                <!-- <input type="checkbox" :id=quest.id :name=quest.id v-model="ranswers[quest.id]"> -->
                <!-- <label :for=quest.id>{{ quest.question }}<a @click.prevent="openImg(quest.image)">(?)</a></label> -->
              </div>
            </div>
          
          </div>
          <div class="body-info answers" v-if="haveAnswer()">
            <ul class="faq">
              <li v-if="havePriceImpactAnswer()">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ff3131" stroke-width="0.00024000000000000003" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.624"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM7.83335 12C7.4963 12 7.19244 12.2088 7.06346 12.5291C6.93447 12.8494 7.00577 13.2181 7.2441 13.4632L11.4107 17.7489C11.7362 18.0837 12.2638 18.0837 12.5893 17.7489L16.7559 13.4632C16.9942 13.2181 17.0655 12.8494 16.9365 12.5291C16.8076 12.2088 16.5037 12 16.1666 12H14V7C14 6.44771 13.5523 6 13 6H11C10.4477 6 10 6.44771 10 7V12H7.83335Z" fill="#ff3131"></path> </g></svg>
                - сильно влияет на стоимость
              </li>
              <li v-if="haveAssessmentAnswer()">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#a6a6a6"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#a6a6a6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 4"></path> </g></svg>
                - учитывается при оценке
              </li>
            </ul>
            <h3>Устройство имеет недостатки</h3>
            <div v-for="(g) in questions">
              <span v-if="haveGroupAnswer(g)">
                <h4>{{ g.name }}</h4>
                <ul>
                  <template v-for="(q) in g.questions.slice().reverse()">
                    <li v-if="isQuestionDefect(q)">
                      <svg v-if="minimumGrade() == q.grade" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ff3131" stroke-width="0.00024000000000000003" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.624"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM7.83335 12C7.4963 12 7.19244 12.2088 7.06346 12.5291C6.93447 12.8494 7.00577 13.2181 7.2441 13.4632L11.4107 17.7489C11.7362 18.0837 12.2638 18.0837 12.5893 17.7489L16.7559 13.4632C16.9942 13.2181 17.0655 12.8494 16.9365 12.5291C16.8076 12.2088 16.5037 12 16.1666 12H14V7C14 6.44771 13.5523 6 13 6H11C10.4477 6 10 6.44771 10 7V12H7.83335Z" fill="#ff3131"></path> </g></svg>
                      <!-- <svg v-if="!(minimumGrade() == q.grade)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#a6a6a6"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM6.5 10.5C5.94772 10.5 5.5 10.9477 5.5 11.5V12.5C5.5 13.0523 5.94772 13.5 6.5 13.5H17.5C18.0523 13.5 18.5 13.0523 18.5 12.5V11.5C18.5 10.9477 18.0523 10.5 17.5 10.5H6.5Z" fill="#a6a6a6"></path> </g></svg> -->
                      <svg v-if="!(minimumGrade() == q.grade)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#a6a6a6"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#a6a6a6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 4"></path> </g></svg>
                      <!-- <svg v-if="!(minimumGrade() == q.grade)" transform="rotate(270)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#a6a6a6" stroke-width="0.00024000000000000003"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.624"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM7.83335 12C7.4963 12 7.19244 12.2088 7.06346 12.5291C6.93447 12.8494 7.00577 13.2181 7.2441 13.4632L11.4107 17.7489C11.7362 18.0837 12.2638 18.0837 12.5893 17.7489L16.7559 13.4632C16.9942 13.2181 17.0655 12.8494 16.9365 12.5291C16.8076 12.2088 16.5037 12 16.1666 12H14V7C14 6.44771 13.5523 6 13 6H11C10.4477 6 10 6.44771 10 7V12H7.83335Z" fill="#a6a6a6"></path> </g></svg> -->
                      {{q.question}}
                    </li>
                  </template>
                  <li class="allGood">Устройство не имеет повреждений</li>
                </ul>
              </span>
            </div>
          </div>
          <div  class="body-info answers" v-else="">
            <h3 class="good">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#00bf63"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM18.4158 9.70405C18.8055 9.31268 18.8041 8.67952 18.4127 8.28984L17.7041 7.58426C17.3127 7.19458 16.6796 7.19594 16.2899 7.58731L10.5183 13.3838L7.19723 10.1089C6.80398 9.72117 6.17083 9.7256 5.78305 10.1189L5.08092 10.8309C4.69314 11.2241 4.69758 11.8573 5.09083 12.2451L9.82912 16.9174C10.221 17.3039 10.8515 17.301 11.2399 16.911L18.4158 9.70405Z" fill="#00bf63"></path></g></svg>
              {{ questionAnswersAsIs === false ? 'Устройство полностью исправно' : 'Устройство находится в идеальном состоянии' }}
            </h3>
            <div
            v-if="user.org != 22"
            class="body-info questions">
              <div
                class="group">
                <div
                  class="question"
                  >
                  <label class="checkbox-container" @mouseenter="checkboxFocus($event,true)" @mouseleave="checkboxFocus($event,false)">Устройство как новое. На устройстве нет царапин, потертостей и иных повреждений
                    <input type="checkbox" v-model="maxGrade" @change="checkboxChange($event)">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            
            </div>
          </div>
        </div>
      </transition>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        :class="{ disabled: requiresAssessmentConfirmation && !hasSelectedAnswer() }"
        @click.prevent="nextPage()">
        Оценить
      </button>
    </div>

    <modal-layout
      :bgShow="assessmentModalShow"
      :modalShow="assessmentModalShow"
      @close="closeAssessmentModal">
      <div class="warning-modal assessment-modal">
        <div class="warning-modal__head">
          <img src="@/../static/img/icons/warning.svg">
          Ошибка
        </div>
        <div class="warning-modal__body">
          <div>
            Вы не прошли процесс технической оценки
          </div>
          <div class="body-info questions assessment-confirm">
            <div class="group">
              <div class="question">
                <label class="checkbox-container" @mouseenter="checkboxFocus($event,true)" @mouseleave="checkboxFocus($event,false)">
                  Да, я все проверил и устройство находится в данном состоянии
                  <input type="checkbox" v-model="assessmentConfirmed" @change="checkboxChange($event)">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="warning-modal__footer">
          <button
            class="btn cancel"
            @click.prevent="closeAssessmentModal">
            Закрыть
          </button>
          <button
            v-if="assessmentConfirmed"
            class="btn next"
            @click.prevent="confirmAssessmentAndContinue">
            Продолжить
          </button>
        </div>
      </div>
    </modal-layout>

    <modal-image />

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import ModalImage from '@/components/Modals/ModalImage';
import ModalLayout from '@/components/Modals/ModalLayout';

export default {
  components: {
    ModalImage,
    ModalLayout,
  },
  props: {
    changeScreenFunction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      error: '',
      ranswers: {},
      grades: null,
      maxGrade: false,
      assessmentModalShow: false,
      assessmentConfirmed: false
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'questions', 'answers','gradeCount', 'questionAnswersAsIs', 'grade', 'price']),
    ...mapState('user', ['user']),
    requiresAssessmentConfirmation() {
      return this.questionAnswersAsIs === false;
    },
  },
  beforeMount() {
    this.grades = new Array(this.gradeCount+1).fill(false);
    for (var a of this.answers){
      if (a.answer) this.ranswers[a.id] = a.answer
    }
  },
  methods: {
    ...mapActions('buyphones', ['getCalc','getSubsidies','setAnswers', 'setError']),
    ...mapMutations('buyphones', ['ADD_ANSWER']),
    ...mapMutations('layout', ['SET_MODAL_IMAGE']),
    isQuestionChecked(question) {
      return !!this.ranswers[question.id]
    },
    isQuestionDefect(question) {
      if (this.questionAnswersAsIs === false) {
        return !this.isQuestionChecked(question)
      }

      return this.isQuestionChecked(question)
    },
    minimumGrade(){
      var minGrade = 0;
      for (const group of this.questions) {
        for (const question of group.questions) {
          if(this.isQuestionDefect(question)){
            minGrade = question.grade > minGrade ? question.grade : minGrade;
          }
        }
      }
      return minGrade
    },
    activeGradeUpdate(){
      this.grades = new Array(this.gradeCount+1).fill(false);
      for (const g of this.questions){
        for (const q of g.questions){
          if (this.isQuestionDefect(q)){
            this.grades[q.grade] = true
          }
        }
      }
    },
    haveAnswer(){
      for (const group of this.questions) {
        for (const question of group.questions) {
          if(this.isQuestionDefect(question)){
            this.maxGrade = false
            return true
          }
        }
      }

      return false
    },
    haveGroupAnswer(group){
      for (const question of group.questions) {
        if(this.isQuestionDefect(question)){
          return true
        }
      }

      return false
    },
    havePriceImpactAnswer(){
      const grade = this.minimumGrade();

      for (const group of this.questions) {
        for (const question of group.questions) {
          if(this.isQuestionDefect(question) && question.grade === grade){
            return true
          }
        }
      }

      return false
    },
    haveAssessmentAnswer(){
      const grade = this.minimumGrade();

      for (const group of this.questions) {
        for (const question of group.questions) {
          if(this.isQuestionDefect(question) && question.grade !== grade){
            return true
          }
        }
      }

      return false
    },
    hasSelectedAnswer(){
      if (this.maxGrade) {
        return true
      }

      for (const id in this.ranswers) {
        if (this.ranswers[id]) {
          return true
        }
      }

      return false
    },
    checkboxChange(e){
      this.$forceUpdate();
      const el = e.srcElement.parentNode.parentNode;
      el.classList.toggle('checked');
      // const checkedStatus = el.classList.contains('checked')
      // var checked = false;
      // for (const child of el.parentNode.children) {
      //   console.log(child)
      //   child.classList.remove("afterChecked")
      //   if(child.classList.contains('checked')){
      //     checked = true;
      //     continue;
      //   }
      //   if (checked){
      //     child.classList.add("afterChecked")
      //   }
      // }
      this.activeGradeUpdate()
    },
    checkboxFocus(e,h){
      const el = e.target.parentNode;
      if (h){
        el.classList.add('hover');
      }else{
        el.classList.remove('hover');
      }
      
      this.activeGradeUpdate()
      var hover = false;
      // for (const child of el.parentNode.children) {
      //   child.classList.remove("afterHover")
      //   if(child.classList.contains('hover')){
      //     hover = true;
      //     continue;
      //   }
      //   if (hover && h){
      //     child.classList.add("afterHover")
      //   }
        
      // }
    },
    openImg(image, description) {
      this.SET_MODAL_IMAGE({
        modal: true,
        bg: true,
        title: '',
        image,
        description: description || '',
      })
    },
    getPayloadAnswer(id) {
      const checked = !!this.ranswers[id];

      if (this.questionAnswersAsIs === false) {
        return !checked;
      }

      return checked;
    },
    formatMtsGrade(grade) {
      if (grade === 'Grade A') {
        return 'Grade H';
      }

      if (grade === 'Grade E') {
        return 'Grade Z';
      }

      return grade;
    },
    formatPrice(price) {
      return new Intl.NumberFormat("ru-RU").format(Number(price));
    },
    showMtsTechnicalGradeChangeWarning(previousGrade, previousPrice, calcResponse) {
      if (this.user.flowType !== 'mts') {
        return;
      }

      const newGrade = calcResponse && calcResponse.grade ? calcResponse.grade : this.grade;
      const newPrice = calcResponse && calcResponse.price !== undefined
        ? calcResponse.price
        : this.price !== undefined
          ? this.price
          : previousPrice;
      const previousMtsGrade = this.formatMtsGrade(previousGrade);
      const newMtsGrade = this.formatMtsGrade(newGrade);
      const previousNumericPrice = Number(previousPrice);
      const newNumericPrice = Number(newPrice);
      const gradeChanged = !!newGrade && previousMtsGrade !== newMtsGrade;
      const priceChanged = Number.isFinite(previousNumericPrice) && Number.isFinite(newNumericPrice)
        ? previousNumericPrice !== newNumericPrice
        : String(previousPrice) !== String(newPrice);

      if (!gradeChanged && !priceChanged) {
        return;
      }

      this.setError({
        type: 'mtsTechnicalGradeChanged',
        grade: newMtsGrade,
        price: this.formatPrice(newPrice),
        currency: this.user.currency,
      });
    },
    async submitAnswers() {
      const previousGrade = this.grade;
      const previousPrice = this.price;
      var calcAnswers = JSON.parse(JSON.stringify(this.answers));

      for (const item of calcAnswers) {
        item.answer = this.getPayloadAnswer(item.id);
      }
      this.setAnswers(calcAnswers)
      const calcResponse = await this.getCalc({
        btag: this.model.btag,
        questions: calcAnswers,
        maxGrade: this.maxGrade 
      })
      this.showMtsTechnicalGradeChangeWarning(previousGrade, previousPrice, calcResponse);

      if (this.changeScreenFunction) {
        this.changeScreenFunction({type: 'next', id: 1});
      } else {
        this.$emit('changeScreen', {type: 'next', id: 1});
      }
    },
    closeAssessmentModal() {
      this.assessmentModalShow = false;
      this.assessmentConfirmed = false;
    },
    async confirmAssessmentAndContinue() {
      this.closeAssessmentModal();
      await this.submitAnswers();
    },
    async nextPage() {
      if (this.requiresAssessmentConfirmation && !this.hasSelectedAnswer()) {
        this.assessmentModalShow = true;
        return;
      }

      await this.submitAnswers();
    }
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/warning-modal.sass'

  .assessment-confirm
    margin-top: 20px
    margin-bottom: 0
    padding-top: 0
    padding-left: 0

    .group
      margin-bottom: 0

    .question
      margin: 0

    .checkbox-container
      display: block
      position: relative
      min-height: 26px
      padding-left: 45px
      margin-bottom: 0
      cursor: pointer
      user-select: none

      input
        position: absolute
        opacity: 0
        cursor: pointer
        height: 0
        width: 0

      .checkmark
        position: absolute
        top: 0
        left: 0
        height: 25px
        width: 25px
        background-color: #eee

      &:hover input ~ .checkmark
        background-color: #e0e0e0

      input:checked ~ .checkmark
        background-color: $darkblue
        opacity: 1

      .checkmark:after
        content: ""
        position: absolute
        display: none
        left: 10px
        top: 6px
        width: 5px
        height: 10px
        border: solid white
        border-width: 0 2px 2px 0
        -webkit-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        transform: rotate(45deg)

      input:checked ~ .checkmark:after
        display: block

  .assessment-modal .warning-modal__footer
    gap: 12px

</style>
